import { AdasBackdrop, AdasCircularProgress } from '@components/wrapper-components'
import { useLoadingStore } from '../../store'

export const LoadingBackdrop = () => {
  const loading = useLoadingStore((store) => store.loading)
  return (
    <AdasBackdrop className='text-[#fff]' style={{ zIndex: 9999 }} open={loading}>
      <AdasCircularProgress color='inherit' />
    </AdasBackdrop>
  )
}
